import { useSelector } from 'react-redux';
import { State } from '@/types';
import { NewLogIn, Ads } from '@/components';
import { DialogsProvider } from './DialogsContext';
import { PublicAuthLayout } from './PublicAuthLayout';

export const LogInPage = () => {
  const { isLoggedIn } = useSelector(({ auth }: State) => auth);
  return (
    <DialogsProvider>
      {isLoggedIn ? (
        <Ads />
      ) : (
        <PublicAuthLayout variant='auth'>
          <NewLogIn isPublicAuthLayout />
        </PublicAuthLayout>
      )}
    </DialogsProvider>
  );
};
